export const insuranceQuestions = {
  booleanOptions: [
    {
      text: "בחר",
      value: ""
    },
    {
      text: "כן",
      value: true
    },
    {
      text: "לא",
      value: false
    }
  ],
  insuranceCompanyOptions: [
    {
      text: "בחר",
      value: ""
    },
    {
      text: "הראל",
      value: "הראל"
    },
    {
      text: "פניקס",
      value: "פניקס"
    },
    {
      text: "מנורה",
      value: "מנורה"
    },
    {
      text: "מגדל",
      value: "מגדל"
    },
    {
      text: "כלל",
      value: "כלל"
    },
    {
      text: "איילון חברה לביטוח",
      value: "איילון חברה לביטוח"
    },
    {
      text: "ביטוח ישיר",
      value: "ביטוח ישיר"
    },
    {
      text: "דיקלה",
      value: "דיקלה"
    },
    {
      text: "אליהו",
      value: "אליהו"
    },
    {
      text: "הכשרה",
      value: "הכשרה"
    }
  ],
  careServicesOptions: [
    { text: "בחר", value: "" },
    { text: "כללית", value: "כללית" },
    { text: "מאוחדת", value: "מאוחדת" },
    { text: "מכבי", value: "מכבי" },
    { text: "לאומית", value: "לאומית" },
    { text: "ללא קופה", value: "ללא קופה" }
  ],
  payOptions: [
    { text: "חברת ביטוח", value: "חברת ביטוח" },
    { text: "מחלקה הבינלאומית", value: "מחלקה הבינלאומית" },
    { text: "מדיקל", value: "מדיקל" },
    { text: "פרטי", value: "פרטי" },
    {
      text: "משרד הבטחון א.מבצעים לוגיסטים",
      value: "משרד הביטחון"
    },
    {
      text: "אגף שיקום",
      value: "אגף שיקום"
    }
  ],
  clalitOptions: [
    { text: "בחר", value: "" },
    { text: "כללית מושלם", value: "כללית מושלם" },
    { text: "חברת ביטוח", value: "חברת ביטוח" },
    { text: "כללית קיצור תורים", value: "כללית קיצור תורים" },
    { text: "פרטי", value: "פרטי" },
    { text: "כללית מחוז דן פתח תקווה", value: "כללית מחוז דן פתח תקווה" },
    { text: "כללית מחוז חיפה גנז", value: "כללית מחוז חיפה גנז" },
    { text: "כללית מחוז ירושלים", value: "כללית מחוז ירושלים" },
    { text: "כללית מחוז מרכז", value: "כללית מחוז מרכז" },
    { text: "כללית מחוז צפון", value: "כללית מחוז צפון" },
    { text: "כללית מחוז תל אביב", value: "כללית מחוז תל אביב" },
    { text: "כללית שרון שומרון", value: "כללית שרון שומרון" },
    { text: "בלינסון", value: "בלינסון" },
    { text: "מחלקה הבינלאומית", value: "מחלקה הבינלאומית" },
    { text: "מדיקל", value: "מדיקל" },
    { text: "מרכז רפואי מאיר", value: "מרכז רפואי מאיר" },
    { text: "מרכז רפואי העמק", value: "מרכז רפואי העמק" },
    {
      text: "משרד הבטחון א.מבצעים לוגיסטים",
      value: "משרד הביטחון"
    },
    {
      text: "אגף שיקום",
      value: "אגף שיקום"
    }
  ],
  meohedetOptions: [
    { text: "בחר", value: "" },
    { text: "מאוחדת שבן", value: "מאוחדת שבן" },
    { text: "מאוחדת סל", value: "מאוחדת סל" }
  ],
  macabiOptions: [
    { text: "בחר", value: "" },
    { text: "מכבי שבן", value: "מכבי שבן" }
    // { text: "מכבי סל", value: "מכבי" }
  ],
  leumitOptions: [
    { text: "בחר", value: "" },
    { text: "לאומית שבן", value: "לאומית שבן" }
    // { text: "לאומית סל", value: "לאומית" }
  ]
  // otherOptions: [
  //   { text: "אבחון מהיר", value: "אבחון מהיר" },
  //   { text: "בלינסון", value: "בלינסון" },
  //   { text: "כללית מחוז דן פתח תקווה", value: "כללית מחוז דן פתח תקווה" },
  //   { text: "כללית מחוז חיפה גנז", value: "כללית מחוז חיפה גנז" },
  //   { text: "כללית מחוז ירושלים", value: "כללית מחוז ירושלים" },
  //   { text: "כללית מחוז מרכז", value: "כללית מחוז מרכז" },
  //   { text: "כללית מחוז צפון", value: "כללית מחוז צפון" },
  //   { text: "כללית מחוז תל אביב", value: "כללית מחוז תל אביב" },
  //   { text: "כללית קיצור תורים", value: "כללית קיצור תורים" },
  //   { text: "כללית שרון שומרון", value: "כללית שרון שומרון" },
  //   { text: "מאוחדת סל", value: "מאוחדת סל" },
  //   { text: "מחלקה הבינלאומית", value: "מחלקה הבינלאומית" },
  //   { text: "מרכז רפואי העמק", value: "מרכז רפואי העמק" },
  //   { text: "מרכז רפואי מאיר", value: "מרכז רפואי מאיר" }
  // ]
};

export const getFullCareServices = type => {
  if (type === "כללית") return "כללית מושלם";
  if (type === "מאוחדת") return "מאוחדת שבן";
  if (type === "לאומית") return "לאומית שבן";
  return type;
};

export const getShortCareServices = type => {
  if (type === "כללית מושלם") return "כללית";
  if (type === "מאוחדת שבן") return "מאוחדת";
  if (type === "לאומית שבן") return "לאומית";
  if (type === "מכבי שלי") return "מכבי";
  return type;
};

export const parentalStatus = [
  { text: "בחר", value: "" },
  { text: "יחידני/ת", value: "single" },
  { text: "נשואים", value: "married" },
  { text: "גרושים", value: "divorced" },
  { text: "אלמנ/ה", value: "widow" }
];

/**
 * Insurance codes that require fetching insurance surgery codes
 * Used by Surgery store and SurgEdit component
 */
export const UNIQUE_INSURANCE_CODES = [
  "1240",
  "1249",
  "1239",
  "1007",
  "1017",
  "3027"
];

/**
 * Implants section trigger surgery codes
 * Used by Surgery store and SurgAdd component
 */
export const implantsTriggerSurgeryCodes = [
  "250.2",
  "209",
  "255.2",
  "257",
  "255.3",
  "255.7",
  "250.3",
  "255.9",
  "255.8",
  "1221",
  "250.4",
  "250",
  "220",
  "254",
  "255.4",
  "1226",
  "268",
  "207",
  "213",
  "236",
  "250.2",
  "209",
  "282.2",
  "1900",
  "235.13",
  "255.2",
  "235.6",
  "242.3",
  "227",
  "257",
  "242.2",
  "242.8",
  "235.12",
  "255.3",
  "235.11",
  "235.8",
  "241.1",
  "221",
  "284",
  "258",
  "255.7",
  "250.3",
  "212",
  "235.17",
  "235.15",
  "224",
  "298",
  "255.9",
  "225",
  "236.2",
  "214",
  "255.8",
  "242.1",
  "1211",
  "235.9",
  "235.14",
  "294",
  "235.18",
  "1221",
  "235.1",
  "244",
  "250.4",
  "235.7",
  "236.1",
  "250",
  "212.6",
  "1232",
  "220",
  "254",
  "273",
  "255.4",
  "242.11",
  "224.5",
  "242.9",
  "242.7",
  "205",
  "239",
  "288",
  "288.1",
  "229",
  "235.5",
  "279",
  "1212",
  "214.1",
  "242.4",
  "282.4",
  "267",
  "1209",
  "242.6",
  "264.1",
  "1226",
  "268",
  "235.16",
  "274",
  "221.5",
  "270.5",
  "953",
  "216",
  "215",
  "264",
  "214.2",
  "272",
  "811"
];
